function getTrafficLightRescoreStrategy(portfolioStrategy, navigationStrategy) {
  return portfolioStrategy || navigationStrategy || "longterm";
}

export { getTrafficLightRescoreStrategy };
